import { getAxisType } from 'helpers/chartHelper';

export const getProjectedSerieType = (
    xType: DataTypesT,
): 'scatter' | 'line' => {
    if (xType === 'year') {
        return 'line';
    }
    return getAxisType(xType) === 'time' ? 'line' : 'scatter';
};
